import { SnapWorkOrderCostResults } from '@calculations/cost/work-order';
import { type Decimal } from '@snap-types/types/decimal';

type StoreCosts = {
  unitCost: Decimal;
  unitBurdenCost: Decimal;
  unitLaborCost: Decimal;
  unitMaterialCost: Decimal;
  unitServiceCost: Decimal;
  unitVariableCosts: Decimal;
};

export function transformWorkOrderCostsToStoreState(
  costs: SnapWorkOrderCostResults,
): StoreCosts {
  return {
    unitCost: costs.unitCost,
    unitBurdenCost: costs.unitBurdenCost,
    unitLaborCost: costs.unitLaborCost,
    unitMaterialCost: costs.unitMaterialCost,
    unitServiceCost: costs.unitServiceCost,
    unitVariableCosts: costs.unitVariableCosts,
  };
}
